import { Controller, FieldValues } from 'react-hook-form';
import { HookFormDropDownFieldProps } from './hookFormDropDownField';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';
import { AppDropdownField } from '../fields/dropdown/dropDownField';

export function HookFormMultipleDropdownField<T extends DropdownOption, TFieldValues extends FieldValues = FieldValues>(
  props: HookFormDropDownFieldProps<T, TFieldValues>,
) {
  const { control, name, rules, options, ...rest } = props;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value, ref }, fieldState: { error }, formState: { isSubmitting } }) => {
        return (
          <div tabIndex={0} ref={ref}>
            {/* @ts-ignore */}
            <AppDropdownField<T>
              isMultiple={true}
              options={options}
              value={options.filter((o) => value?.includes(o.key)) || []}
              onChange={(v) => onChange(v?.map((x) => x.key))}
              {...rest}
              errorProps={{
                ...props.errorProps,
                errors: error?.message ?? props.errorProps?.errors,
              }}
              disabled={props.disabled || isSubmitting}
            />
          </div>
        );
      }}
    />
  );
}
